import React from 'react';
import type { PatientDetailsPatientProp } from './internal';
import {
  getPatientDetailsUnknownString,
  PatientDetailsSection
} from './internal';
import { intl } from '../../lib';
import { Collapsible } from '../basic';

/**
 * Props for a {@link PatientDetailsQRcode} component.
 */
export type PatientDetailsQRcodeProps = PatientDetailsPatientProp & {
  readonly openInitially?: boolean;
};

/**
 * Component for displaying a patient's QR code for mobile app.
 *
 * @param properties a {@link PatientDetailsPatientProp} object
 * @return the created {@link JSX.Element}.
 * @constructor
 */
export function PatientDetailsQRcode({
  patient,
  openInitially = false,
  ...props
}: Readonly<PatientDetailsQRcodeProps>): JSX.Element {
  const styledQRcode =
    patient?.qrcodeSVG &&
    `<html>
      <body style="margin: auto; overflow: hidden">
          ${patient.qrcodeSVG
            .replace(/width="\d+"/g, 'width="100"')
            .replace(/height="\d+"/g, 'height="100"')}
      </body>
    </html>`;

  if (!patient.qrcodeSVG) {
    return <></>;
  }

  return (
    <PatientDetailsSection {...props} className="ehs-patient-details-qr-code">
      <Collapsible
        triggerText={intl('patientsearchportlet.view.details.qrcode')}
        aria-label={intl('patientsearchportlet.view.details.qrcode')}
        openInitially={openInitially}
      >
        <iframe srcDoc={styledQRcode} sandbox={''} className="qr-code-svg" />
      </Collapsible>
    </PatientDetailsSection>
  );
}
